import { Component, EventEmitter, Injector, Output, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { FindProductOutputDto, FindVendorOutputDto } from '@shared/service-proxies/service-proxies';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import {
    CommonLookupServiceProxy
} from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'app-search-vendor',
  standalone: false,
  
  templateUrl: './search-vendor.component.html',
    styleUrl: './search-vendor.component.css',
  
})
export class SearchVendorComponent {
    @Input() vendorSelectedItem: FindVendorOutputDto;
    @Output() vendorEvent = new EventEmitter<FindVendorOutputDto>();
    vendors: FindVendorOutputDto[];
    /*productSelectedItem: FindProductOutputDto;*/
    filterText = '';

    constructor(
        private _commonLookupServiceProxy: CommonLookupServiceProxy
    ) {

    }


    filterProducts(event: AutoCompleteCompleteEvent) {
        this.filterText = event.query.toLowerCase();
        this.getVendors();
    }

    onVendorSelected(event: any) {
        this.vendorEvent.emit(event.value);
    }


    getVendors() {
        this._commonLookupServiceProxy
            .getAllVendorForLookupTable(this.filterText, undefined, undefined, 100000)
            .subscribe((result) => {
                this.vendors = result.items;
            });
    }
}
